<template>
  <div class="filtros">
    <FiltrosCheckPoints />
  </div>
</template>

<script>
  // Components
  import FiltrosCheckPoints from "./FiltrosCheckPoints/FiltrosCheckPoints"
  

  export default {
    name: "Filtros",
    components: {
      FiltrosCheckPoints
    }
  }
</script>

<style scoped>
    .filtros {
        width: 102%;
        height: 30vh;
        margin-bottom:50px;
    }

</style>

